module.exports = __webpack_public_path__ + "static/media/spicyshrimp.9f9c0d2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/protein/spicyshrimp.jpg
// module id = 113
// module chunks = 0